<template>
  <v-row 
    id="navigation-buttons"
    class="d-flex align-items-center p-0"
  >
    <v-col
      v-if="$vuetify.breakpoint.mobile"
      class="justify-start p-0"
    >
      <MobileMenu />
    </v-col>
    <v-col class="d-flex justify-end p-0">
      <v-btn
        class="mr-2"
        :disabled="activeTab == 0"
        color="primary"
        :class="{
          'custom-slick-border' : isMobile ,
          'custom-slick-border-hover' : !isMobile ,
          'bg-transparent border-white ' : $store.state.module.view_dark,
        }"
        outlined
        fab
        small
        @click="decrease"
      >
        <i 
          :class="{
            'white--text' : $store.state.module.view_dark,
          }"
          class="fas fa-chevron-left fa-2x mr-1"
        />
      </v-btn>
      <span class="mx-1">
        <v-tooltip
          v-if="contents.length != activeTab"
          top
          max-width="400px"
          :open-on-click="true"
        >
          <template #activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >
              <v-btn
                rounded
                :color="btnFinishColor"
                :disabled="btnFinishIsDisabled"
                class="font-weight-bold px-4"
                :class="{
                  'disabled' : btnFinishIsDisabled,
                  'bg-transparent border border-white custom-slick-border' : $store.state.module.view_dark,
                }"
                @click="finish_content(content)"
              >
                <span
                  :class="{
                    'white--text' : $store.state.module.view_dark,
                  }"
                >
                  {{ btnFinishText }}
                </span>
              </v-btn>
            </span>
          </template>
          <span>
            {{ btnFinishToolTipTitle }}
          </span>
        </v-tooltip>
      </span>
      <v-btn
        class="ml-2"
        :class="{
          'custom-slick-border' : isMobile ,
          'custom-slick-border-hover' : !isMobile ,
          'bg-transparent border-white ' : $store.state.module.view_dark,
        }"
        color="primary"
        :disabled="isLastTab || !content.finished_at"
        outlined
        fab
        small
        @click="increase"
      >
        <i
          class="fas fa-chevron-right fa-2x ml-1"
          :class="{
            'white--text' : $store.state.module.view_dark,
          }"
        />
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
  import { finishContent } from '@/student/api/Content.js'
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import stopVideos from "@/common/utils/stopVideos"
  import ActiveTabMixin from './ActiveTabMixin'
  import { nitro } from '@/constants/colors'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: { MobileMenu },
    mixins: [ActiveTabMixin],
    data() {
      return {
        nitro,
        not_enough_time_message: 'Parece que você ainda não dedicou tempo suficiente a este conteúdo. Estude e clique neste botão ao concluir.',
        request_time: 0,
        slow_time: 15,
      }
    },
    computed: {
      ...mapGetters(['module','contents','completed_contents','uncompleted_contents','cycles','selectedCycle']),
      isMobile() {
        return this.$vuetify.breakpoint.mobile
      },
      releaseBtnFinish(){
        return this.content && !this.content.finished_at && this.content.released_to_finish
      },
      showLastButton() {
        return this.isLastTab
      },
      showNextButton() {
        return false || !this.showLastButton
      },
      isLastTab() {
        return this.activeTab == this.contents.length - 1
      },
      btnFinishToolTipTitle() {
        return this.content && this.content.finished_at
          ? 'O conteúdo já foi concluído'
          : this.content && this.content.released_to_finish
          ? 'Marcar conteúdo como concluído' : this.not_enough_time_message
      },
      btnFinishColor(){
        return this.$store.state.module.view_dark ? 'default' : 'primary'
      },
      btnFinishIsDisabled(){
        return !this.content || !!this.content.finished_at || !this.content.released_to_finish
      },
      btnFinishText(){
        return this.content && this.content.finished_at ? 'Concluído' : 'Concluir'
      }
    },
    
    methods: {
      ...mapMutations(['SET_MODULE','SET_CYCLES','SET_CYCLE']),
      ...mapActions(['load']),
      finish_content(content) {
        
        if (this.releaseBtnFinish) {
          
          let nIntervId
          
          nIntervId = setInterval(() => {
            this.request_time+=1
            if(this.request_time>=this.slow_time){
              this.load({
                isLoading: true, 
                message: 'O processo está demorando mais do que o normal. Por favor, aguarde.'
              })
            }
          }, 1000)
          
          this.load({isLoading: true, message: 'Finalizando...'})
  
          finishContent(content.id)
          .then(({data: {data: module}}) => {
          
            module.activeTab = this.isLastTab ? this.activeTab : this.activeTab+1
            
            this.SET_MODULE(module)

            this.SET_CYCLES(this.cycles.map(c=> ({
              ...c,
              modules: c.modules.map(m => m.id == module.id ? module : m)
            })))

            this.SET_CYCLE({
              ...this.selectedCycle,
              modules: this.selectedCycle.modules.map(m => m.id == module.id ? module : m)
            })
  
            if (module.module_progress>=100) {
              this.$notify({ type: 'success', text: 'Módulo concluído.'})
            }
  
          })
          .finally(() => {
            this.load(false)
            clearInterval(nIntervId)
            this.request_time = 0
          })
        }
      },
      increase() {
        stopVideos();
        this.activeTab += this.activeTab < this.contents.length - 1 ? 1 : 0
      },
      decrease() {
        stopVideos();
        this.activeTab -= this.activeTab > 0 ? 1 : 0
      }
    }
  }
</script>
<style scoped>
.custom-slick-border-hover{
  border: none
}
.custom-slick-border-hover:hover{
  border: solid;
  border-width: 1px !important
}
</style>